import { IMAGES } from "@/lib/site";

const CARDS = [
  {
    img: IMAGES.gallery1,
    alt: "Trimble robotic total station leveled on a geodetic survey monument",
    title: "Boundary & Monumentation",
    sub: "Millimeter-level geodetic control"
  },
  {
    img: IMAGES.gallery2,
    alt: "High-definition 3D laser scanner capturing complex site topography",
    title: "HDS Laser Scanning",
    sub: "High-density point clouds for civil design"
  },
  {
    img: IMAGES.gallery3,
    alt: "Civil engineering stormwater detention pond grading drawings",
    title: "Stormwater & Pond Modeling",
    sub: "Hydrologic drainage calculations"
  },
  {
    img: IMAGES.gallery4,
    alt: "Heavy civil earthmover bulldozer equipped with GPS 3D machine control masts",
    title: "3D Machine Guidance",
    sub: "Trimble Earthworks & Topcon surfaces"
  }
];

export const FieldGallery = () => (
  <section id="field-gallery" className="py-20 bg-stone-100 border-b border-stone-200" data-testid="field-gallery-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
        <div>
          <h2 className="text-xs font-bold uppercase tracking-widest text-amber-800 mb-2">Field Documentation &amp; Technology</h2>
          <p className="font-display text-3xl font-bold text-stone-950">Active Geomatic Operations</p>
        </div>
        <p className="text-xs font-semibold text-stone-500 mt-2 md:mt-0 uppercase tracking-wider">Trimble GNSS · HDS Laser Scanning · Civil 3D</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {CARDS.map((card, i) => (
          <div key={card.title} className="rounded-xl overflow-hidden border border-stone-300 aspect-[4/3] relative flex flex-col justify-end p-4 shadow-sm group" data-testid={`gallery-card-${i + 1}`}>
            <img
              src={card.img}
              alt={card.alt}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-stone-950/80 via-stone-900/20 to-transparent"></div>
            <div className="relative z-10 text-white">
              <span className="block text-xs font-bold">{card.title}</span>
              <span className="block text-[11px] text-stone-300">{card.sub}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
